import { Name } from "../../name/index.js";
export function hasName(nameOrPredicate = () => true, ...names) {
    const predicate = typeof nameOrPredicate === "function"
        ? nameOrPredicate
        : Name.hasValue(nameOrPredicate, ...names);
    return (node) => node.name.some(predicate);
}
//# sourceMappingURL=has-name.js.map